import { PageTitleFrame, Spacer } from '../..';

// SECTION: Test Code
const Test = () => {
  return (
    <PageTitleFrame title='Testing Page' noBottomRule>
      <Spacer padding={2} />

      <Spacer padding={2} />
    </PageTitleFrame>
  );
};

export default Test;
